import { render, staticRenderFns } from "./ClientesPopup.vue?vue&type=template&id=6468081f&scoped=true"
import script from "./ClientesPopup.vue?vue&type=script&lang=js"
export * from "./ClientesPopup.vue?vue&type=script&lang=js"
import style0 from "./ClientesPopup.vue?vue&type=style&index=0&id=6468081f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468081f",
  null
  
)

export default component.exports